import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrAvailabilityGridDayStatus.ts
var t = () => e("availabilityGridDayStatus");
//#endregion
export { t as useTrAvailabilityGridDayStatus };
